<template>
    <el-container style="height:inherit;width:100%;" id="container1">
     <!-- 侧边栏 -->
      <el-aside id="elAside" v-bind:class="{ 'aside-scrollbar':true,activeStyle: isActive, 'text-act': isActives }" >
        <el-scrollbar style="height:100%;">
          <div style="margin:30px 0px 50px 0px;text-align:center;color:#eb6100;box-sizing: border-box;" >
            <p style="font-size:43px;text-shadow:rgb(112 106 106 / 32%) 4px 4px 1px;"><strong>TIAO MI</strong></p>
            <p style="font-size:20px;font-weight: 700;">跳米科技</p>
          </div>
          <!-- 菜单 -->
          <side-list></side-list>
        </el-scrollbar> 
      </el-aside>
      <el-container style="height:inherit;width:100%;" id="container2">
          <el-header class="tm-top" style="height: 95px;padding: 0px;">
            <div class="flexs align-items-center" style="justify-content: space-between;height: 56px;line-height: 56px;border-bottom: 2px solid #ececec;padding: 0px 18px;">
              <div>
                <!-- 面包屑 -->
                <el-breadcrumb style="font-size:14px;">
                  <el-breadcrumb-item v-for="(item,index) in crumbsArrss" :key="index" :to="{ path: item.url }">
                    <i class="el-icon-s-shop" v-if="index == 0"></i>
                    {{item.name}}
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="flexs align-items-center">
                <p class="userTitle">{{userName}}</p>
                <img src="../../assets/img/close_1.png" @click="signOut()" style="width:24px;height:24px;cursor: pointer;" alt="" />
              </div>
            </div>
            <!-- TAB -->
            <div class="tabsViews" style="padding-left: 13px;">
              <tabsViews/>
            </div>
          </el-header>
   
        <el-main id="elMain" style="height:100%;">
          <el-scrollbar style="height:calc(100% - 12px);" class="main-scorllbar">
            <!-- 主体内容 -->
            <div id="mainView" style="height:100%;">
                <transition name="fade-transform" mode="out-in">
                  <keep-alive :include="cachedViews">
                    <router-view style="padding-top:12px;" ></router-view>
                  </keep-alive>
                </transition>
            </div>
            <!-- 返回顶部 -->
            <el-backtop target="#elMain .el-scrollbar__wrap" :bottom="72" :right="22"></el-backtop>
          </el-scrollbar>
        </el-main>
      </el-container>
      <el-dialog title="退出平台" :visible.sync="SignOut.show" width="550px" :close-on-click-modal="false">
        <div style="font-size:16px;text-align:center;">
          <div style="padding-bottom:14px;"><img src="../../assets/img/tuichu.png" style="width:120px;"></div>
          <strong>确定要退出平台吗？</strong> 
        </div>
        <span slot="footer" class="dialog-footer" >
            <el-button size="mini" round @click="cancel()">取 消</el-button>
            <el-button size="mini" round type="primary" @click="handleAdopt('SignOut')">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
    
</template>

<script>
import SideList from './SideList.vue'
import tabsViews from './tabsViews'
import { mapState,mapActions } from "vuex";
  export default {
    name: 'HelloWorld',
    data () {
      return {
        originalVal:[],
        isCollapse:false,
        isActive:true,
        isActives:false,
        SignOut:{
          show:false,
        }
      }
    },
    components:{
      SideList,tabsViews
    },
    computed:{
      ...mapState({  //比如'movies/hotMovies
        userName:state=>state.userName
      }),
      crumbsArrss(){
        let aa =[];
        if((this.$store.state.crumbsArr[0] == undefined) && (this.$store.state.crumbsArr.length != 1)){
          aa = [{name:'首页',url:'/home'}];
          return aa
        }else {
          aa = this.$store.state.crumbsArr;
          if(aa[0].name == '首页'){
            aa = [{name:'首页',url:'/home'}];
          }
          return aa;
        }
      },
      cachedViews(){
        return this.$store.state.cachedViews;
      },
    },
    created(){
      //获取用户信息
      this.$api.post(this.API.api + 'home/getLoginUserInfo',{},res=>{
        let param={
          userName:res.data.userName,
          name:res.data.name,
          roleId:res.data.roleId,
          roleName:res.data.roleName,
          roleType:res.data.roleType
        }   
        this.saveInfo(param);
      })
    },
    methods:{
      ...mapActions([  //比如'movies/getHotMovies
        'saveInfo',
        'saveMenuWidth'
      ]),
      //(确定))退出
      handleAdopt(){
        this.$api.post(this.API.api + 'home/logOut',{},res=>{
          if(this.$common.getCookie('tibiot-personal-card')){
            document.cookie='tibiot-personal-card='+ this.$common.getCookie('tibiot-personal-card') +';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';  //清除token
            window.localStorage.removeItem("vuex-along"); //清除vue-along
          }
          this.$router.push("./login");
        })
      },
      //取消
      cancel(){
        this.SignOut.show = false; //弹框关闭
        this.$message.info('已取消操作');
      },
      //退出
      signOut(){
        this.SignOut.show = true;
      },
    
    }
  }
</script>
<style scoped>
#container1{
  background: url('../../assets/img/T250910-1.svg') no-repeat;
  background-size: 480px 480px;
  background-position: 40px -120px; 
}
#container2{
  background: url('../../assets/img/T250910-2.svg') no-repeat;
  background-size: 366px 366px;
  background-position: right 88px bottom 56px;
}
#main-header{
  height: 34px !important;
}
#main-header>div{
  font-size:14px !important;
  height: 34px !important;
  line-height: 34px!important;
}
#mainView{
  padding:0px 17px;
}
#elMain{
  padding:12px 0px 0px;
  box-sizing:border-box;
  background-color: rgba(255,255,255,0.8);
  border-radius: 11px;
  margin: 0px 17px 17px 0px;
}
#elAside{
  background-image: url('../../assets/img/T250910-2.svg');
  background-size: 120px 120px;
  background-repeat: no-repeat;
  background-position: right 8px bottom -18px;
}
.tm-top{
  margin: 17px 17px 12px 0px; 
  background-color: rgba(255,255,255,0.8);
  border-radius: 11px;
  
}
.el-main {
  color: #666;
}
.userTitle{
  font-weight: bold;
  padding-right: 14px;
}
.activeStyle{
  height:calc(100% - 34px) !important;
  width:220px !important;
  margin: 17px 12px 17px 17px;
  transition: width 0.2s;
  border-radius: 11px;
  background-color: rgba(255,255,255,0.8);
}
.text-act{
  height:inherit !important;
  width:60px !important;
  transition: width 0.2s;
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
<style>
/* 禁止横向滚动条*/
.aside-scrollbar .el-scrollbar__wrap,.main-scorllbar .el-scrollbar__wrap{
  overflow-x: hidden !important;
}
</style>


// WEBPACK FOOTER //
// src/views/components/HelloWorld.vue